import {
  Text,
  Button,
  IconChevronDown,
  IconChevronTop,
  GreyGrey70,
  Primary13SemiBold
} from '@sequencehq/core-components'

type Props = {
  text: string
  isVisible: boolean
  toggle: () => void
  'data-testid'?: string
}

export const SidebarSectionToggle = ({
  text,
  isVisible,
  toggle,
  'data-testid': dataTestId
}: Props) => {
  const iconProps = {
    width: '16px',
    height: '16px',
    color: 'black'
  }

  return (
    <Button
      variant="unstyled"
      onClick={toggle}
      data-testid={dataTestId}
      style={{
        minWidth: 'initial',
        minHeight: 'initial',
        height: 'initial',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '16px'
      }}
    >
      <Text {...Primary13SemiBold} color={GreyGrey70}>
        {text}
      </Text>

      {isVisible ? (
        <IconChevronDown {...iconProps} />
      ) : (
        <IconChevronTop {...iconProps} />
      )}
    </Button>
  )
}
